// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";

const initialState = {
  institutions: [],
  loading: false,
  value: 0,
};

export const getInstitutions = createAsyncThunk(
  "posts/getInstitutions",
  async (search = "", thunkAPI) => {
    const res = await http.get(`/institutions?${search}`);
    return res.data.sort((a, b) => a.name.localeCompare(b.name));
  },
);

const institutionsSlice = createSlice({
  name: "institutions",
  initialState,
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
  extraReducers: {
    [getInstitutions.pending]: state => {
      state.loading = true;
    },
    [getInstitutions.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.institutions = payload;
    },
    [getInstitutions.rejected]: state => {
      state.loading = false;
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  updateUnitOnList,
} = institutionsSlice.actions;

export const institutionsReducer = institutionsSlice.reducer;
